import { DatePipe } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { crop_Datas } from 'src/app/models/farmer-land.model';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { FarmerLandDetailService } from 'src/app/services/farmer-land-detail.service';
import { FarmersApplicationService } from 'src/app/services/farmers-application.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import * as XLSX from 'xlsx';

interface UploadEvent {
  originalEvent: Event;
  files: File[];
}

@Component({
  selector: 'app-new-work',
  templateUrl: './new-work.component.html',
  styleUrls: ['./new-work.component.scss'],
  providers: [DatePipe],
})
export class NewWorkComponent implements OnInit {
  public outletMasterData: any;

  public selectedOutlet: any = null;
  public selectedOutletToGetData: any = null;
  public selectedBenefitedArea: any = null;
  public selectedBenefitedAreaToGetData: any = null;
  public agreementNo: any = null;
  public agreementNoToGetData: any = null;

  public ipAddress: any;
  public isSubmitted: boolean = false;
  public userId: any;
  public contractorId: any;
  public subscriptions: any = [];
  public subjectSub: any;

  public xslxToJsonDataPersonal: any[] = [];
  public xslxToJsonDataLand: any[] = [];
  public xslxToJsonDataBank: any[] = [];
  public uploadFile: any;
  public personalDetailsCols: any[];
  public landDetailsCols: any[];
  public bankDetailsCols: any[];
  public showViewDocDialog: boolean = false;

  public personalDetailsForm: FormGroup;
  public updatePersonalDetailsForm: FormGroup;
  public addedPersonalData: any[] = [];
  public todayDate: Date;

  public filteredVillage: any[];
  public villageList: any;

  public isCasteCertificteOptional: boolean = false;
  public isCasteCertificateMandatory: boolean = false;

  public farmerLandForm: FormGroup;
  public cropMergeList: any;
  public nodes2: any[];
  public cropTypeList: any[];
  public submitted: boolean = false;
  public valRadio: boolean = false;
  selectedNodes1: any[] = [];
  selectedCorpModelList: any;
  selectedCorpModel: crop_Datas;
  blockSpace: RegExp = /^[^\s,]([^,]*[^\s,])?$/;

  public addedLandData: any = [];

  public landDocArray: any = [];

  public uploadedlandFiles: any[] = [];
  public uploadedAadharFiles: any[] = [];
  public selectedcompMaster: any;
  // public selectedFarmerCategory: any;

  public contractorOutletList = [];
  public componentMasterList = [];
  public componentMasterListForEstimation = [];
  public farmerCategoryList = [];

  // public filteredComponentMaster: any[];

  public departmentList = [
    { name: 'Agriculture', code: 'Agriculture' },
    { name: 'Horticulture', code: 'Horticulture' },
    { name: 'MICADA 1.0', code: 'MICADA' },
  ];

  public yearArray: any = [];

  public innerWidth: number;
  public showSubsidyArea: boolean = false;
  public minDate: Date;
  public maxDate: Date;

  public addedFarmerData: any = [];

  public estimationDetailsForm: FormGroup;
  public filteredmiVendorList: any = [];
  public miVendorList: any = [];
  public category: any;
  public component: any;
  public sizePrice: any;
  // public enteredQuantity: any;
  public estimationTableData: any = [];

  expandedRows: any = {};

  public hideGetDataButton: boolean = false;
  public farmerPastSubsidyList: any = [];

  public totalPortableAreaCount: any = 0;
  public totalPortableCount: any = 0;
  public totalMiniAreaCount: any = 0;
  public totalMiniCount: any = 0;
  public totalDripAreaCount: any = 0;
  public totalDripCount: any = 0;

  public programWiseData: any = [];
  public agreementNoList: any = [];

  public showErrMsgOfInvArea: boolean = false;
  public invAreaMsg: any;

  public showUpdatePersonalDialog: boolean = false;

  public selectedApplicationNo: any;
  public selectedFarmerId: any;
  public loadedEstimateDatafromServer: any = [];

  public chunkList: any = [];
  public chunkIdToGetData: any;

  public selectedFarmerForEstimation: any = [];
  public consentCheckBox: any = [];

  public grandTotalCost: any = 0;
  public grandTotalQuantity: any = 0;

  constructor(
    private deptDashBoardService: DepartmentDashboardService,
    private loader: AppLoaderService,
    private activityRecordService: ActivityRecordService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private _personalDetalSer: FarmersDetailsService,
    private datePipe: DatePipe,
    private ipService: IpAddressService,
    private fb: FormBuilder,
    private flService: FarmerLandDetailService,
    private fApplicationService: FarmersApplicationService,
    private vendorService: VendorDashboardService,
    private cryptoJsService: CryptoJsService,
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  ngOnInit(): void {
    // this.todayDate = new Date();
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));
    this.contractorId = JSON.stringify(token?.officeCode);
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.getContractorOutletList(this.contractorId, 0, '');
    this.getIP();
    this.getCorpType();
    this.getFarmerCategoryList();
    this.getYearList();
    this.loadComponentMaster();

    this._personalDetalSer.getVillageMatserData().subscribe((res) => {
      // this.loader.close();
      this.villageList = res;
      this.filteredVillage = [...this.villageList];

      // if (this.farmerData?.Village_Code) {
      //   let village = this.villageList?.filter(val => val?.Code === this.farmerData?.Village_Code)[0]
      //   this.farmersFormControls.village.setValue(village?.Name);
      //   this.selectedVillage = village;
      // }

      if (!window.localStorage.getItem('villageMaster')) {
        window.localStorage.setItem('villageMaster', JSON.stringify(res));
      }
    });

    this.personalDetailsForm = this.fb.group({
      name: ['', Validators.required],
      // farmerPhoto: ['', Validators.required],
      // gender: ['', Validators.required],

      fatherName: ['', Validators.required],
      // motherName: ['', Validators.required],
      // dob: ['', Validators.required],

      // emailId: ['', Validators.compose([Validators.required, Validators.email])],
      mobileNo: [
        '',
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      casteCode: ['', Validators.required],
      // casteCertificate: ['', Validators.required],

      // address: ['', Validators.required],
      villageCode: ['', Validators.required],
      // pinCode: ['', Validators.required],

      mfmbNo: [
        '',
        [Validators.required, Validators.minLength(8), Validators.maxLength(8)],
      ],
      aadharNo: [
        '',
        [
          Validators.required,
          Validators.minLength(12),
          Validators.maxLength(12),
        ],
      ],
      componentMaster: ['', Validators.required],
      farmerCategory: ['', Validators.required],
      aadharPhotoPath: ['', Validators.required],

      pppId: [
        '',
        [Validators.required, Validators.minLength(8), Validators.maxLength(8)],
      ],
      // pppPhotoPath: ['', Validators.required],
      // pppPhotoPath: ['', Validators.required],

      isSubsidyAvailabe: ['', Validators.required],
      installedSystem: ['', Validators.required],
      yearSubsudy: ['', Validators.required],
      onCostSubsidyBased: [0, Validators.required],
      departmentSubsidy: ['', Validators.required],
    });

    this.updatePersonalDetailsForm = this.fb.group({
      name: ['', Validators.required],
      fatherName: ['', Validators.required],
      mobileNo: [
        '',
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      casteCode: ['', Validators.required],
      villageCode: ['', Validators.required],
      mfmbNo: [
        '',
        [Validators.required, Validators.minLength(8), Validators.maxLength(8)],
      ],
      aadharNo: [
        '',
        [
          Validators.required,
          Validators.minLength(12),
          Validators.maxLength(12),
        ],
      ],
      componentMaster: ['', Validators.required],
      farmerCategory: ['', Validators.required],
      aadharPhotoPath: ['', Validators.required],

      pppId: [
        '',
        [Validators.required, Validators.minLength(8), Validators.maxLength(8)],
      ],

      isSubsidyAvailabe: ['', Validators.required],
      installedSystem: ['', Validators.required],
      yearSubsudy: ['', Validators.required],
      onCostSubsidyBased: [0, Validators.required],
      departmentSubsidy: ['', Validators.required],
    });

    this.farmerLandForm = this.fb.group({
      morabbaNumber: [, [Validators.required]],
      killaNumber: [, [Validators.required]],
      totalArea: ['', [Validators.required]],
      kanals: [
        '',
        Validators.compose([Validators.required, Validators.max(8)]),
      ],
      marlas: [
        '',
        Validators.compose([Validators.required, Validators.max(20)]),
      ],
      villageCode: ['', [Validators.required]],
      cropType: ['', [Validators.required]],
      // crop: ['', [Validators.required]],
      // IsSubsidyAvailabe: ['', [Validators.required]],
      // IsSubsidyAvailabe: [''],
      landdoc_Path: ['', [Validators.required]],
    });

    this.estimationDetailsForm = this.fb.group({
      programmeName: ['', [Validators.required]],
      // vendor: ['', [Validators.required]],
      category: ['', [Validators.required]],
      component: ['', [Validators.required]],
      sizePrice: ['', [Validators.required]],
      enteredQuantity: ['', [Validators.required, Validators.min(0)]],
      perUnitCost: ['', [Validators.required, Validators.min(0)]],
      // conPrice: ['', [Validators.required, Validators.min(0)]],
      coveredArea: ['', [Validators.required, Validators.min(0)]],
    });

    // this.getOutletRD();
  }

  get f() {
    return this.farmerLandForm.controls;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  getYearList() {
    let today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();
    let prevMonth = month === 0 ? 11 : month - 1;
    let prevYear = prevMonth === 11 ? year - 8 : year - 7;
    let nextMonth = month === 11 ? 0 : month + 1;
    let nextYear = nextMonth === 0 ? year : year;
    this.minDate = new Date();
    this.minDate.setMonth(prevMonth);
    this.minDate.setFullYear(prevYear);
    this.maxDate = new Date();
    this.maxDate.setMonth(nextMonth);
    this.maxDate.setFullYear(nextYear);
    this.innerWidth = window.innerWidth;

    for (
      let i = this.minDate.getFullYear();
      i <= this.maxDate.getFullYear();
      i++
    ) {
      this.yearArray.push({ name: i.toString(), code: i.toString() });
    }
  }

  onSelectOutlet() {
    this.selectedBenefitedArea = this.selectedOutlet?.CCA_A;
  }

  onSelectOutletToGetData() {
    this.agreementNoToGetData = null;
    this.agreementNoList = [];
    this.chunkList = [];

    this.agreementNoToGetData = null;
    this.chunkIdToGetData = null;

    this.selectedBenefitedAreaToGetData = this.selectedOutletToGetData?.CCA_A;

    let conId = this.selectedOutletToGetData?.ContractorCode;
    let outletId = this.selectedOutletToGetData?.OutletId;
    this.getAgreementNumberList(conId, outletId, this.userId, '');
  }

  getAgreementNumberList(contractorId, outletId, userId, status) {
    this.loader.start();
    this.fApplicationService
      .getAgreementByContractor(contractorId, outletId, userId, status)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.agreementNoList = res;
        },
        error: (err) => {
          this.loader.close();
          this.agreementNoList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectBenefitedArea() {
  }

  checkAadharNumber(event: any) {
    const aadharNumber = event.target.value;
    if (aadharNumber.length === 12) {
      this.checkFarmerPastSubsidy(aadharNumber);
    }
  }

  checkFarmerPastSubsidy(aadharNo) {
    this.loader.start();
    this.fApplicationService
      .getFarmerPastSubsidyByAadharNo(aadharNo)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();

          if (res.length > 0) {
            this.farmerPastSubsidyList = res;
          } else {
            this.farmerPastSubsidyList = [];
          }
        },
        error: (err) => {
          this.farmerPastSubsidyList = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  getContractorOutletList(contractorId, userId, status) {
    this.loader.start();
    this.fApplicationService
      .getOutletByContractor(contractorId, userId, status)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.contractorOutletList = res;
        },
        error: (err) => {
          this.loader.close();
          this.contractorOutletList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  getFarmerCategoryList() {
    this.loader.start();
    this.fApplicationService
      .getFarmerCategory()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.farmerCategoryList = res;
        },
        error: (err) => {
          this.loader.close();
          this.farmerCategoryList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
    // setTimeout(() => {
    //   this.farmerCategoryList = [
    //     {
    //       AutoID: 1,
    //       Type: 'Big',
    //     },
    //     {
    //       AutoID: 3,
    //       Type: 'Small',
    //     },
    //     {
    //       AutoID: 2,
    //       Type: 'Marginal',
    //     }
    //   ];
    // }, 100);
  }

  filterVillage(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.villageList.length; i++) {
      const village = this.villageList[i];
      if (village.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(village);
      }
    }

    this.filteredVillage = filtered;
  }

  // getOutletRD() {
  //   this.loader.start();
  //   let sub = this.deptDashBoardService
  //     .getOutletMasterForCanal()
  //     .pipe(first())
  //     .subscribe({
  //       next: (data) => {
  //         this.loader.close();
  //         // this.activityRecordService.activityRecord(this.userId, 'Outlet Master For Canal', '', new Date(), 'Success');


  //         if (data.length > 0) {
  //           // this.outletMasterData = data;
  //         }
  //         else {
  //           // this.outletMasterData = [];
  //           this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
  //         }
  //       },
  //       error: (err) => {
  //         this.loader.close();
  //         // this.outletMasterData = [];
  //         this.activityRecordService.activityRecord(this.userId, 'Outlet Master For Canal', '', new Date(), err);

  //         this.messageService.add({
  //           severity: 'error',
  //           summary: 'Error Message',
  //           detail: err,
  //         });
  //       },
  //     });

  //   this.subscriptions.push(sub);
  // }

  loadComponentMaster() {
    // this.fApplicationService.getComponentMaster().subscribe(res => {
    //   this.componentMasterList = res;
    //   this.filteredComponentMaster = [...this.componentMasterList]

    // })

    setTimeout(() => {
      (this.componentMasterList = [
        {
          Program_Id: 1,
          Program_Name: 'Portable Sprinkler',
          Active: true,
        },
        {
          Program_Id: 2,
          Program_Name: 'Mini Sprinkler',
          Active: true,
        },
        {
          Program_Id: 3,
          Program_Name: 'Drip',
          Active: true,
        },
      ])
      // (this.filteredComponentMaster = [...this.componentMasterList]);
    }, 100);
  }

  getIP() {
    const encData = JSON.parse(this.cryptoJsService.DecryptDataPayload(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let ipAddress = farmerConfData.get('ipAddress');

    if (ipAddress) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;

        farmerConfData.set('ipAddress', this.ipAddress)

        const dataF = JSON.stringify(Array.from(farmerConfData.entries()));
        sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));  
      });
    }
  }

  // onUploadPersonalDetails(event, formcontrol, uploadElement) {
  //   this.uploadFile = [];
  //   let workBook = null;
  //   let jsonData = null;
  //   let sheetName = null
  //   const reader = new FileReader();
  //   let file = event.files[0];
  //   this.uploadFile = file;
  //   reader.onload = (event) => {
  //     const data = reader.result;
  //     workBook = XLSX.read(data, { type: 'binary', cellText:false, cellDates:true });
  //     jsonData = workBook.SheetNames.reduce((initial, name) => {
  //       sheetName = name;
  //       const sheet = workBook.Sheets[name];
  //       initial[name] = XLSX.utils.sheet_to_json(sheet, {
  //         raw: true,
  //         dateNF:'yyyy-mm-dd',
  //       });
  //       return initial;
  //     }, {});
  //     const dataString = JSON.stringify(jsonData);
  //     let personalData = JSON.parse(dataString)[sheetName];
  //     // this.xslxToJsonDataPersonal = JSON.parse(dataString)[sheetName];
  //     // if (!(this.xslxToJsonDataPersonal)) {
  //     if (!(personalData)) {
  //       this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'The Uploaded file has invalid data "or" Multiple sheet data is not supported!' });
  //     // }else if(this.xslxToJsonDataPersonal.length == 0){
  //     }else if(personalData.length == 0){
  //       this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'The Uploaded file is empty!' });
  //     }else{
  //       // this.onOpenPersonalDialog();
  //       // this.uploadPersonalDeatilsTableData(this.xslxToJsonDataPersonal);

  //       this.uploadPersonalDeatilsTableData(personalData);
  //     }
  //   }
  //   reader.readAsBinaryString(file);
  //   uploadElement.clear();
  // }

  // onCasteChange(event, ...value){
  //   // this.isCasteCertificateMandatory = false;
  //   // let val = 0;
  //   // if(value.length > 0){
  //   //   val = value[0];
  //   // }else{
  //   //   val = this.personalDetailsForm.value['casteCode'];
  //   // }
  //   // if(val == 1){
  //   //   this.isCasteCertificteOptional = false;
  //   //   this.isCasteCertificateMandatory = false;
  //   //   this.personalDetailsForm.controls['casteCertificate'].clearValidators();
  //   //   this.personalDetailsForm.controls['casteCertificate'].updateValueAndValidity();
  //   //   this.personalDetailsForm.controls['casteCertificate'].setValue('');
  //   // }else if(val == 2){
  //   //   this.isCasteCertificteOptional = true;
  //   //   this.isCasteCertificateMandatory = false;
  //   //   this.personalDetailsForm.controls['casteCertificate'].clearValidators();
  //   //   this.personalDetailsForm.controls['casteCertificate'].updateValueAndValidity();
  //   //   this.personalDetailsForm.controls['casteCertificate'].setValue('');
  //   // }else{
  //   //   this.isCasteCertificteOptional = false;
  //   //   this.isCasteCertificateMandatory = true;
  //   //   this.personalDetailsForm.controls['casteCertificate'].setValidators(Validators.required);
  //   //   this.personalDetailsForm.controls['casteCertificate'].updateValueAndValidity();
  //   // }
  // }

  // onUploadLandDetails(event, formcontrol, uploadElement) {
  //   this.uploadFile = [];
  //   let workBook = null;
  //   let jsonData = null;
  //   let sheetName = null
  //   const reader = new FileReader();
  //   let file = event.files[0];
  //   this.uploadFile = file;
  //   reader.onload = (event) => {
  //     const data = reader.result;
  //     workBook = XLSX.read(data, { type: 'binary', cellText:false, cellDates:true });
  //     jsonData = workBook.SheetNames.reduce((initial, name) => {
  //       sheetName = name;
  //       const sheet = workBook.Sheets[name];
  //       initial[name] = XLSX.utils.sheet_to_json(sheet, {
  //         raw: true,
  //         dateNF:'yyyy-mm-dd',
  //       });
  //       return initial;
  //     }, {});
  //     const dataString = JSON.stringify(jsonData);
  //     let landData = JSON.parse(dataString)[sheetName];
  //     if (!(landData)) {
  //       this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'The Uploaded file has invalid data "or" Multiple sheet data is not supported!' });
  //     }else if(landData.length == 0){
  //       this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'The Uploaded file is empty!' });
  //     }else{
  //       this.uploadLandDeatilsTableData(landData);
  //     }
  //   }
  //   reader.readAsBinaryString(file);
  //   uploadElement.clear();
  // }

  // onUploadBankDetails(event, formcontrol, uploadElement) {
  //   this.uploadFile = [];
  //   let workBook = null;
  //   let jsonData = null;
  //   let sheetName = null
  //   const reader = new FileReader();
  //   let file = event.files[0];
  //   this.uploadFile = file;
  //   reader.onload = (event) => {
  //     const data = reader.result;
  //     workBook = XLSX.read(data, { type: 'binary', cellText:false, cellDates:true });
  //     jsonData = workBook.SheetNames.reduce((initial, name) => {
  //       sheetName = name;
  //       const sheet = workBook.Sheets[name];
  //       initial[name] = XLSX.utils.sheet_to_json(sheet, {
  //         raw: true,
  //         dateNF:'yyyy-mm-dd',
  //       });
  //       return initial;
  //     }, {});
  //     const dataString = JSON.stringify(jsonData);
  //     let bankData = JSON.parse(dataString)[sheetName];
  //     if (!(bankData)) {
  //       this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'The Uploaded file has invalid data "or" Multiple sheet data is not supported!' });
  //     }else if(bankData.length == 0){
  //       this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'The Uploaded file is empty!' });
  //     }else{
  //       this.uploadBankDeatilsTableData(bankData);
  //     }
  //   }
  //   reader.readAsBinaryString(file);
  //   uploadElement.clear();
  // }

  // uploadBankDeatilsTableData(data){
  //   this.xslxToJsonDataBank = data.map(val => ({
  //     ...val,
  //     // 'DOB': this.datePipe.transform(new Date(val.DOB), 'yyyy-MM-dd'),
  //     // 'Upload Aadhar Doc' : null,
  //     'Upload Bank Doc' : null
  //   }))

  //   this.bankDetailsCols = [];
  //   let colHeaders = Object.keys(this.xslxToJsonDataBank[0]);
  //   colHeaders.forEach(elem => {
  //     this.bankDetailsCols.push({ field: elem, header: elem })
  //   });
  // }

  // uploadLandDeatilsTableData(data){
  //   this.xslxToJsonDataLand = data.map(val => ({
  //     ...val,
  //     // 'DOB': this.datePipe.transform(new Date(val.DOB), 'yyyy-MM-dd'),
  //     // 'Upload Aadhar Doc' : null,
  //     'Upload Land Doc' : null
  //   }))

  //   this.landDetailsCols = [];
  //   let colHeaders = Object.keys(this.xslxToJsonDataLand[0]);
  //   colHeaders.forEach(elem => {
  //     this.landDetailsCols.push({ field: elem, header: elem })
  //   });
  // }

  // uploadPersonalDeatilsTableData(data){
  //   // this.datePipe.transform(new Date(val.fromDate), 'yyyy-MM-dd');

  //   this.xslxToJsonDataPersonal = data.map(val => ({
  //     ...val,
  //     'DOB': this.datePipe.transform(new Date(val.DOB), 'yyyy-MM-dd'),
  //     'Upload Aadhar Doc' : null,
  //     'Upload PPP Id Doc' : null
  //   }))

  //   this.personalDetailsCols = [];
  //   let colHeaders = Object.keys(this.xslxToJsonDataPersonal[0]);
  //   colHeaders.forEach(elem => {
  //     this.personalDetailsCols.push({ field: elem, header: elem })
  //   });
  // }

  // onUploadDoc(event, uploadElement, actionType, row, col){
  //     let file = event.files[0];
  //     let data = new FormData();
  //     data.append('file', file);
  //     this.loader.start();
  //     this._personalDetalSer
  //     .uploadFile(data, this.userId, actionType)
  //     .subscribe((resp: any) => {
  //       this.loader.close();
  //       if (resp.statusCode == 200) {

  //         if(actionType == 'personalDetails'){
  //           if(col.field == 'Upload Aadhar Doc'){
  //             let user = this.xslxToJsonDataPersonal.find(val => val['Aadhar No'] == row['Aadhar No']);
  //             if (user) {
  //               user['Upload Aadhar Doc'] = resp.data;
  //             }
  //           }else if(col.field == 'Upload PPP Id Doc'){
  //             let user = this.xslxToJsonDataPersonal.find(val => val['Aadhar No'] == row['Aadhar No']);
  //             if (user) {
  //               user['Upload PPP Id Doc'] = resp.data;
  //             }
  //           }
  //         }else if(actionType == 'landDetails'){
  //           if(col.field == 'Upload Land Doc'){
  //             let user = this.xslxToJsonDataLand.find(val => val['Aadhar No'] == row['Aadhar No']);
  //             if (user) {
  //               user['Upload Land Doc'] = resp.data;
  //             }
  //           }
  //         }else if(actionType == 'bankDetails'){
  //           if(col.field == 'Upload Bank Doc'){
  //             let user = this.xslxToJsonDataBank.find(val => val['Account No'] == row['Account No']);
  //             if (user) {
  //               user['Upload Bank Doc'] = resp.data;
  //             }
  //           }
  //         }

  //         // if(col.field == 'Upload Aadhar Doc'){
  //         //   if(actionType == 'personalDetails'){
  //         //     let user = this.xslxToJsonDataPersonal.find(val => val['Aadhar No'] == row['Aadhar No']);
  //         //     if (user) {
  //         //       user['Upload Aadhar Doc'] = resp.data;
  //         //     }
  //         //   }else if( actionType == 'landDetails'){

  //         //   }else if( actionType == 'bankDetails'){

  //         //   }

  //         // }else if(col.field == 'Upload PPP Id Doc'){
  //         //   if(actionType == 'personalDetails'){
  //         //     let user = this.xslxToJsonDataPersonal.find(val => val['Aadhar No'] == row['Aadhar No']);
  //         //     if (user) {
  //         //       user['Upload PPP Id Doc'] = resp.data;
  //         //     }
  //         //   }else if( actionType == 'landDetails'){

  //         //   }else if( actionType == 'bankDetails'){

  //         //   }
  //         // }else if(col.field == 'Upload Land Doc'){
  //         //   if(actionType == 'personalDetails'){

  //         //   }else if( actionType == 'landDetails'){
  //         //     let user = this.xslxToJsonDataLand.find(val => val['Aadhar No'] == row['Aadhar No']);
  //         //     if (user) {
  //         //       user['Upload Land Doc'] = resp.data;
  //         //     }
  //         //   }else if( actionType == 'bankDetails'){

  //         //   }
  //         // }

  //         this.messageService.add({
  //           severity: 'success',
  //           summary: 'Success',
  //           detail: 'File Uploaded Successfully',
  //         });
  //       }else{
  //         this.loader.close();
  //         this.messageService.add({
  //           severity: 'error',
  //           summary: 'Error',
  //           detail: 'File Not Uploaded',
  //         });
  //       }
  //     });

  //     uploadElement.clear();
  // }

  // onOpenPersonalDialog() {
  //   this.cols = [];
  //   let colHeaders = Object.keys(this.xslxToJsonDataPersonal[0]);
  //   colHeaders.forEach(elem => {
  //     this.cols.push({ field: elem, header: elem })
  //   });
  //   this.showViewDocDialog = true;
  // }

  // onClosePersonalDialog() {
  //   this.showViewDocDialog = false;
  // }

  // clearUploadPersonalDetail(val) {

  //   this.confirmationService.confirm({
  //     target: event.target as EventTarget,
  //     message: `Do you want to remove ${val} record?`,
  //     header: 'Delete Confirmation',
  //     icon: 'pi pi-info-circle',
  //     acceptButtonStyleClass:"p-button-danger p-button-text",
  //     rejectButtonStyleClass:"p-button-text p-button-text",
  //     acceptIcon:"none",
  //     rejectIcon:"none",

  //     accept: () => {
  //       if(val == 'personal'){
  //         this.xslxToJsonDataPersonal = [];
  //         this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'Personal Details Data Removed Successfully' });
  //       }else if(val == 'land'){
  //         this.xslxToJsonDataLand = [];
  //         this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'Land Details Data Removed Successfully' });
  //       }else if(val == 'bank'){
  //         this.xslxToJsonDataBank = [];
  //         this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'Bank Details Data Removed Successfully' });
  //       }
  //     },
  //     reject: () => {
  //       // this.messageService.add({ severity: 'info', summary: 'Rejected', detail: 'You have rejected' });
  //     }
  //   });
  // }

  // onClickSaveData(actionType){
  //   if(actionType == 'personalDetails'){
  //     let flag = this.xslxToJsonDataPersonal.some(val => val['Upload Aadhar Doc'] == null || val['Upload PPP Id Doc'] == null);
  //     if(flag){
  //       this.messageService.add({
  //         severity: 'error',
  //         summary: 'Error',
  //         detail: 'Please upload all personal details related documents',
  //       });
  //     }else{
  //       this.messageService.add({
  //         severity: 'success',
  //         summary: 'Success',
  //         detail: 'Data Uploaded Successfully',
  //       });
  //     }
  //   }else if(actionType == 'landDetails'){
  //     let flag = this.xslxToJsonDataLand.some(val => val['Upload Land Doc'] == null);
  //     if(flag){
  //       this.messageService.add({
  //         severity: 'error',
  //         summary: 'Error',
  //         detail: 'Please land related documents',
  //       });
  //     }else{
  //       this.messageService.add({
  //         severity: 'success',
  //         summary: 'Success',
  //         detail: 'Data Uploaded Successfully',
  //       });
  //     }
  //   }else if(actionType == 'bankDetails'){
  //     let flag = this.xslxToJsonDataPersonal.some(val => val['Upload Bank Doc'] == null);
  //     if(flag){
  //       this.messageService.add({
  //         severity: 'error',
  //         summary: 'Error',
  //         detail: 'Please upload all bank related documents',
  //       });
  //     }else{
  //       this.messageService.add({
  //         severity: 'success',
  //         summary: 'Success',
  //         detail: 'Data Uploaded Successfully',
  //       });
  //     }
  //   }
  // }

  deleteLand(val, index) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Do you want to remove land record of Morabba No: ${val?.morabbaNumber} and Killa No: ${val?.killaNumber}?`,
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: 'p-button-danger p-button-text',
      rejectButtonStyleClass: 'p-button-text p-button-text',
      acceptIcon: 'none',
      rejectIcon: 'none',

      accept: () => {
        this.addedLandData.splice(index, 1);
      },
      reject: () => {
        // this.messageService.add({ severity: 'info', summary: 'Rejected', detail: 'You have rejected' });
      },
    });
  }

  deleteFarmerDetails(val, index) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Do you want to remove farmer ${val?.farmername}?`,
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: 'p-button-danger p-button-text',
      rejectButtonStyleClass: 'p-button-text p-button-text',
      acceptIcon: 'none',
      rejectIcon: 'none',

      accept: () => {
        this.addedFarmerData.splice(index, 1);
      },
      reject: () => {
        // this.messageService.add({ severity: 'info', summary: 'Rejected', detail: 'You have rejected' });
      },
    });
  }

  // onUpload(event, formcontrol, uploadElement) {
  //   let file = event.files[0];
  //   let data = new FormData();
  //   data.append('file', file);
  //   this._personalDetalSer.uploadFile(data, phNo, formcontrol).subscribe((resp: any) => {
  //     if (resp.statusCode == 200) {
  //       this.personalDetailsForm.patchValue({ [formcontrol]: resp.data });
  //     }
  //   })
  //   uploadElement.clear();
  // }

  onSubmitLandDetails() {
    this.submitted = true;

    if (this.farmerLandForm.valid && this.selectedNodes1.length < 5) {
      let landDetails = this.farmerLandForm.value;

      // landDetails.map(val => ({
      //   ...val,
      //   cropValue: landDetails.cropType.map(item => item.label).join(', ')
      // }))

      let landDetailsToAdd = {
        ...landDetails,
        marlas: this.farmerLandForm.controls['marlas'].value,
        villageCode: landDetails?.villageCode?.Code,
        cropValue: landDetails.cropType.map((item) => item.label).join(', '),
      };

      this.addedLandData.push(landDetailsToAdd);

      this.farmerLandForm.reset();
      this.uploadedlandFiles = [];
      this.submitted = false;

      // this.markFormGroupUntouched(this.farmerLandForm);
      // this.markFormGroupPristine(this.farmerLandForm);
    } else {
      this.farmerLandForm.markAllAsTouched();
    }
  }

  // addedLandDataInTable(){
  //   if (this.farmerLandForm.valid) {
  //     this.addedLandData.push(this.farmerLandForm.value);
  //     this.farmerLandForm.reset();
  //     this.submitted = false;
  //     // this.markFormGroupUntouched(this.farmerLandForm);
  //     // this.markFormGroupPristine(this.farmerLandForm);
  //   } else {
  //     this.farmerLandForm.markAllAsTouched();
  //   }
  // }

  // private markFormGroupUntouched(formGroup: FormGroup) {
  //   (Object as any).values(formGroup.controls).forEach((control: any) => {
  //     control.markAsUntouched();

  //     if (control.controls) {
  //       this.markFormGroupUntouched(control);
  //     }
  //   });
  // }

  // private markFormGroupPristine(formGroup: FormGroup) {
  //   (Object as any).values(formGroup.controls).forEach((control: any) => {
  //     control.markAsPristine();

  //     if (control.controls) {
  //       this.markFormGroupPristine(control);
  //     }
  //   });
  // }

  onKanalsChange() {
    let tlk: any = 0.0; // sample kanal variable
    let tlm: any = 0.0; // sample marlas variable
    this.f.marlas.setValue(0);
    if (this.f.kanals.value) {
      if (parseInt(this.f.kanals.value) >= 8) {
        this.f.marlas.setValue(0);
        this.f.marlas.disable();
        // tlm = 1;
      } else {
        this.f.marlas.enable();
      }
      tlk = parseInt(this.f.kanals.value) * 0.125;
    }
    if (this.f.marlas.value) {
      tlm = parseInt(this.f.marlas.value) * 0.006249999998;
    }

    let tl = tlk + tlm;
    const totalArea = tl.toFixed(2);
    this.f.totalArea.setValue(Number(totalArea));
  }

  onMarlasChange() {
    let tlk: any = 0.0;
    let tlm: any = 0.0;
    if (this.f.kanals.value != undefined || this.f.kanals.value != '') {
      tlk = (this.f.kanals.value ? parseInt(this.f.kanals.value) : 0) * 0.125;
    }
    if (this.f.marlas.value != undefined || this.f.marlas.value != '') {
      tlm =
        (this.f.marlas.value ? parseInt(this.f.marlas.value) : 0) *
        0.006249999998;
    }
    // if (this.f.marlas.value > 19){
    //   this.f.marlas.setValue()
    // }

    let tl = tlk + tlm;
    this.f.totalArea.setValue(parseFloat(tl).toFixed(2));
  }

  getCorpType() {
    this.flService
      .GetCorpType()
      .pipe(first())
      .subscribe({
        next: (files) => {
          this.nodes2 = files;
          this.cropTypeList = files;

          let arrayCrop = [];
          let cropMerge = files.map((parent) => {
            arrayCrop.push(
              parent['children'].map((child) => ({
                ...child,
                parentData: parent.data,
                parentLabel: parent.label,
              }))
            );
          });

          this.cropMergeList = [].concat(...arrayCrop);
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Corp Type Details not loaded.',
          });
        },
      });
  }

  public setCurrentPosition() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.showPosition(position);
      });
    }
  }

  showPosition(position) {
    let geocoder = new google.maps.Geocoder();
    let latlng = {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    };
    this.f.latitude.setValue(position.coords.latitude);
    this.f.longitude.setValue(position.coords.longitude);
  }

  getSelectedCorpType() {
    this.selectedCorpModel = new crop_Datas();
    this.selectedCorpModelList = [];
    let selectedLabels = [];

    this.selectedCorpModelList = this.selectedNodes1.map((val) => ({
      type_of_crop_ID: val.parentData,
      crop_ID: val.data,
    }));

    // for (let result of this.selectedNodes1) {
    //   if (result.parent) {
    //     if(selectedLabels.includes(result.label)){
    //       break;
    //     }
    //     let body = {
    //       crop_ID : result.data,
    //       type_of_crop_ID: result.parent?.data
    //     }
    //     this.selectedCorpModelList.push(body);
    //     selectedLabels.push(result.label);
    //   }else if(result.children){
    //     result.children.forEach(child => {
    //       if(selectedLabels.includes(child.label)){
    //         return;
    //       }
    //       let body = {
    //         crop_ID : child.data,
    //         type_of_crop_ID: (child.parent?.data) ? child.parent?.data : result.data
    //       }

    //       this.selectedCorpModelList.push(body);
    //       selectedLabels.push(child.label);
    //     })
    //   }
    // }
  }

  onCropSelect(val) {
    if (val.value.length > 4) {
      this.messageService.add({
        severity: 'info',
        summary: 'Crop Limit Exceeds',
        detail: 'Maximun 4 crop is allowed',
      });
    }
  }

  // filterComponentMaster(event: any) {
  //   const filtered: any[] = [];
  //   const query = event.query;
  //   for (let i = 0; i < this.componentMasterList.length; i++) {
  //     const wq = this.componentMasterList[i];
  //     if (wq.Program_Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
  //       filtered.push(wq);
  //     }
  //   }

  //   this.filteredComponentMaster = filtered;
  // }

  onAadharUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);

    // this.landDocArray = [];

    // this.landDocArray.push({
    //   value: data,
    //   name: formcontrol
    // })

    const encData = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encData);

    const tokenInfo = loginDetails.get('tokenInfo') ? loginDetails.get('tokenInfo') : null;
    const officeCode = tokenInfo['officeCode'] ? tokenInfo['officeCode'] : null;

    this.loader.start();
    this._personalDetalSer
      .uploadFile(data, officeCode, formcontrol)
      .subscribe((resp: any) => {
        this.loader.close();
        if (resp.statusCode == 200 && resp.message == 'Sucessfull') {
          this.uploadedAadharFiles = [];
          for (let file of event.files) {
            this.uploadedAadharFiles.push(file);
          }

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Aadhar Uploaded Successfully',
          });
          this.personalDetailsForm.patchValue({ [formcontrol]: resp.data });
        }
      });
    uploadElement.clear();
  }

  onUpdateAadharUpload(event, formcontrol, uploadElement) {
    const encData = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encData);

    const tokenInfo = loginDetails.get('tokenInfo') ? loginDetails.get('tokenInfo') : null;
    const officeCode = tokenInfo['officeCode'] ? tokenInfo['officeCode'] : null;


    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);

    this.loader.start();
    this._personalDetalSer
      .uploadFile(data, officeCode, formcontrol)
      .subscribe((resp: any) => {
        this.loader.close();
        if (resp.statusCode == 200 && resp.message == 'Sucessfull') {
          this.uploadedAadharFiles = [];
          for (let file of event.files) {
            this.uploadedAadharFiles.push(file);
          }

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Aadhar Uploaded Successfully',
          });
          this.updatePersonalDetailsForm.patchValue({ [formcontrol]: resp.data });
        }
      });
    uploadElement.clear();
  }

  onLandUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);

    // this.landDocArray = [];

    // this.landDocArray.push({
    //   value: data,
    //   name: formcontrol
    // })
    const encData = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encData);

    const tokenInfo = loginDetails.get('tokenInfo') ? loginDetails.get('tokenInfo') : null;
    const officeCode = tokenInfo['officeCode'] ? tokenInfo['officeCode'] : null;

    this.loader.start();
    this._personalDetalSer
      .uploadFile(data, officeCode, formcontrol)
      .subscribe((resp: any) => {
        this.loader.close();
        if (resp.statusCode == 200 && resp.message == 'Sucessfull') {
          this.uploadedlandFiles = [];
          for (let file of event.files) {
            this.uploadedlandFiles.push(file);
          }

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'File Uploaded Successfully',
          });
          this.farmerLandForm.patchValue({ [formcontrol]: resp.data });
        }
      });
    uploadElement.clear();
  }

  onSelectSubsidyAvail(val) {
    if (val == 1) {
      this.personalDetailsForm.controls['installedSystem'].setValidators(
        Validators.required
      );
      this.personalDetailsForm.controls[
        'installedSystem'
      ].updateValueAndValidity();
      this.personalDetailsForm.controls['yearSubsudy'].setValidators(
        Validators.required
      );
      this.personalDetailsForm.controls['yearSubsudy'].updateValueAndValidity();
      this.personalDetailsForm.controls['onCostSubsidyBased'].setValidators(
        Validators.required
      );
      this.personalDetailsForm.controls[
        'onCostSubsidyBased'
      ].updateValueAndValidity();
      this.personalDetailsForm.controls['departmentSubsidy'].setValidators(
        Validators.required
      );
      this.personalDetailsForm.controls[
        'departmentSubsidy'
      ].updateValueAndValidity();
    } else {
      this.personalDetailsForm.controls['installedSystem'].clearValidators();
      this.personalDetailsForm.controls[
        'installedSystem'
      ].updateValueAndValidity();
      this.personalDetailsForm.controls['yearSubsudy'].clearValidators();
      this.personalDetailsForm.controls['yearSubsudy'].updateValueAndValidity();
      this.personalDetailsForm.controls['onCostSubsidyBased'].clearValidators();
      this.personalDetailsForm.controls[
        'onCostSubsidyBased'
      ].updateValueAndValidity();
      this.personalDetailsForm.controls['departmentSubsidy'].clearValidators();
      this.personalDetailsForm.controls[
        'departmentSubsidy'
      ].updateValueAndValidity();

      // this.personalDetailsForm.controls.installedSystem.setValue('');
    }
  }

  onSelectSubsidyAvailUpdate(val) {
    if (val == 1) {
      this.updatePersonalDetailsForm.controls['installedSystem'].setValidators(
        Validators.required
      );
      this.updatePersonalDetailsForm.controls[
        'installedSystem'
      ].updateValueAndValidity();
      this.updatePersonalDetailsForm.controls['yearSubsudy'].setValidators(
        Validators.required
      );
      this.updatePersonalDetailsForm.controls['yearSubsudy'].updateValueAndValidity();
      this.updatePersonalDetailsForm.controls['onCostSubsidyBased'].setValidators(
        Validators.required
      );
      this.updatePersonalDetailsForm.controls[
        'onCostSubsidyBased'
      ].updateValueAndValidity();
      this.updatePersonalDetailsForm.controls['departmentSubsidy'].setValidators(
        Validators.required
      );
      this.updatePersonalDetailsForm.controls[
        'departmentSubsidy'
      ].updateValueAndValidity();
    } else {
      this.updatePersonalDetailsForm.controls['installedSystem'].clearValidators();
      this.updatePersonalDetailsForm.controls[
        'installedSystem'
      ].updateValueAndValidity();
      this.updatePersonalDetailsForm.controls['yearSubsudy'].clearValidators();
      this.updatePersonalDetailsForm.controls['yearSubsudy'].updateValueAndValidity();
      this.updatePersonalDetailsForm.controls['onCostSubsidyBased'].clearValidators();
      this.updatePersonalDetailsForm.controls[
        'onCostSubsidyBased'
      ].updateValueAndValidity();
      this.updatePersonalDetailsForm.controls['departmentSubsidy'].clearValidators();
      this.updatePersonalDetailsForm.controls[
        'departmentSubsidy'
      ].updateValueAndValidity();

      // this.updatePersonalDetailsForm.controls.installedSystem.setValue('');
    }
  }

  onSelectOnCostS(val) {
    if (val == 1) {
      this.personalDetailsForm.controls['departmentSubsidy'].setValidators(
        Validators.required
      );
      this.personalDetailsForm.controls[
        'departmentSubsidy'
      ].updateValueAndValidity();
    } else {
      this.personalDetailsForm.controls['departmentSubsidy'].clearValidators();
      this.personalDetailsForm.controls[
        'departmentSubsidy'
      ].updateValueAndValidity();
    }
  }

  onSubmitPersonalDetails() {
    if (this.personalDetailsForm.valid) {
      // this.addedPersonalData.push(this.personalDetailsForm.value);
      // this.personalDetailsForm.reset();
    } else {
      this.personalDetailsForm.markAllAsTouched();
    }
  }

  onAddFarmerForm() {
    this.onSubmitPersonalDetails();

    if (this.selectedOutlet == null) {
      this.messageService.add({
        severity: 'info',
        summary: 'Info',
        detail: 'Select Outlet.',
      });
      return;
    }

    if (this.agreementNo == null) {
      this.messageService.add({
        severity: 'info',
        summary: 'Info',
        detail: 'Enter Agreement No.',
      });
      return;
    }

    if (this.personalDetailsForm.invalid) {
      this.messageService.add({
        severity: 'info',
        summary: 'Info',
        detail: 'Fill Personal Details Properly.',
      });
      return;
    }

    if (this.addedLandData.length == 0) {
      this.messageService.add({
        severity: 'info',
        summary: 'Info',
        detail: 'Fill Land Detail.',
      });
      return;
    }

    let personalDetails = this.personalDetailsForm.value;
    let addedLandDetails = this.addedLandData;

    let farmerDeatils = {
      landDetailsData: addedLandDetails,
      contractorId: this.contractorId,
      outletId: this.selectedOutlet?.OutletId,
      agreementNo: this.agreementNo,
      name: personalDetails?.name,
      farmerFatherName: personalDetails?.fatherName,
      ppP_ID: personalDetails?.pppId,
      aadharno: personalDetails?.aadharNo,
      aadhar_path: personalDetails?.aadharPhotoPath,
      mobileno: personalDetails?.mobileNo,
      castcode: personalDetails?.casteCode,
      villagecode: personalDetails?.villageCode?.Code,
      mfmbNo: personalDetails?.mfmbNo,
      farmerCategory: personalDetails?.farmerCategory?.AutoID,
      proposedSystemToBeInstalled: personalDetails?.componentMaster?.Program_Id,

      isSubsidyAvailabe: personalDetails?.isSubsidyAvailabe
        ? personalDetails?.isSubsidyAvailabe
        : 0,
      installedSystem: personalDetails?.installedSystem?.Program_Id
        ? personalDetails?.installedSystem?.Program_Id
        : 0,
      yearSubsudy: personalDetails?.yearSubsudy
        ? personalDetails?.yearSubsudy
        : '',
      onCostSubsidyBased: personalDetails?.onCostSubsidyBased
        ? personalDetails?.onCostSubsidyBased
        : 0,
      departmentSubsidy: personalDetails?.departmentSubsidy
        ? personalDetails?.departmentSubsidy
        : '',

      network_ID: this.ipAddress,
      terminal_ID: this.ipAddress,
    };

    this.submitFarmerData([farmerDeatils]);
    // this.addedFarmerData.push(farmerDeatils);

    // this.personalDetailsForm.reset();
    // this.uploadedAadharFiles = [];
    // this.addedLandData = [];
  }

  onUpdatePersonalDetails() {

    if (this.updatePersonalDetailsForm.valid) {
      this.updatePersonalDetails();
      // this.addedPersonalData.push(this.personalDetailsForm.value);
      // this.personalDetailsForm.reset();
    } else {
      this.updatePersonalDetailsForm.markAllAsTouched();
      this.messageService.add({
        severity: 'info',
        summary: 'Info',
        detail: 'Fill Personal Details Properly.',
      });
      return;
    }
  }

  submitFarmerData(reqBody) {
    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.vendorService
      .insertFarmerDataByContractor(reqBodyFinal)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          if (res == 'Success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: 'Details submitted successfully.',
            });

            this.personalDetailsForm.reset();
            this.uploadedAadharFiles = [];
            this.addedLandData = [];
            // this.selectedOutlet = null;
            // this.agreementNo = null;
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: res,
            });
          }
          this.activityRecordService.activityRecord(this.userId, 'EPC Work Submit(Farmer Data)', `${reqBody?.outletId}_${reqBody?.agreementNo}`, new Date(), `${res}`, JSON.stringify(reqBody));
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(this.userId, 'EPC Work Submit Error(Farmer Data)', `${reqBody?.outletId}_${reqBody?.agreementNo}`, new Date(), `${err}`, JSON.stringify(reqBody));
        },
      });
  }


  updatePersonalDetails() {
    let updatedPersonalDetails = this.updatePersonalDetailsForm.value;

    let reqBoady = {
      FarmerId: this.selectedFarmerId,
      // contractorId: this.contractorId,
      // outletId: this.selectedOutlet?.OutletId,
      // agreementNo: this.agreementNo,
      name: updatedPersonalDetails?.name,
      farmerFatherName: updatedPersonalDetails?.fatherName,
      ppP_ID: updatedPersonalDetails?.pppId,
      aadharno: updatedPersonalDetails?.aadharNo,
      aadhar_path: updatedPersonalDetails?.aadharPhotoPath,
      mobileno: updatedPersonalDetails?.mobileNo,
      castcode: updatedPersonalDetails?.casteCode,
      villagecode: updatedPersonalDetails?.villageCode?.Code,
      mfmbNo: updatedPersonalDetails?.mfmbNo,
      farmerCategory: updatedPersonalDetails?.farmerCategory,
      proposedSystemToBeInstalled: updatedPersonalDetails?.componentMaster,

      isSubsidyAvailabe: updatedPersonalDetails?.isSubsidyAvailabe ? updatedPersonalDetails?.isSubsidyAvailabe : 0,
      installedSystem: updatedPersonalDetails?.installedSystem ? updatedPersonalDetails?.installedSystem : 0,
      yearSubsudy: updatedPersonalDetails?.yearSubsudy ? updatedPersonalDetails?.yearSubsudy : '',
      onCostSubsidyBased: updatedPersonalDetails?.onCostSubsidyBased ? updatedPersonalDetails?.onCostSubsidyBased : 0,
      departmentSubsidy: updatedPersonalDetails?.departmentSubsidy ? updatedPersonalDetails?.departmentSubsidy : '',

      network_ID: this.ipAddress,
      terminal_ID: this.ipAddress,
    };

    // this.submitFarmerData([farmerDeatils]);
    this.updateFarmerPersonalData(reqBoady);
  }

  updateFarmerPersonalData(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.vendorService
      .updateFarmerPersonalDetails(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          if (res == 'Personal details updated successfully.') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: res,
            });

            this.updatePersonalDetailsForm.reset();
            this.uploadedAadharFiles = [];
            this.onCloseUpdatePerDialog();
            this.onClickGetFarmerData();
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Error Message',
              detail: res,
            });
          }

          this.activityRecordService.activityRecord(this.userId, 'EPC Work Update (Personal Details)', `${reqBody?.outletId}_${reqBody?.agreementNo}`, new Date(), `${res}`, JSON.stringify(reqBody));

        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
          this.activityRecordService.activityRecord(this.userId, 'EPC Work Update Error(Personal Details)', `${reqBody?.outletId}_${reqBody?.agreementNo}`, new Date(), `${err}`, JSON.stringify(reqBody));
        },
      });
  }

  clearFormData() {
    this.personalDetailsForm.reset();
    this.uploadedAadharFiles = [];
    this.addedLandData = [];
    this.farmerPastSubsidyList = [];
  }

  onClickGetFarmerData() {
    let outletId = this.selectedOutletToGetData?.OutletId;
    let agreementNo = this.agreementNoToGetData?.AgreementNo;
    let chunkId = this.chunkIdToGetData?.ChunkId ? this.chunkIdToGetData?.ChunkId : 0;

    this.estimationTableData = [];
    this.addedFarmerData = [];

    if (outletId && agreementNo) {
      if (chunkId != 0) {
        this.getEPCFarmerDetails(agreementNo, outletId, chunkId);
        this.getEPCEstimationDetails(this.contractorId, outletId, agreementNo, chunkId);
      } else {
        this.getEPCFarmerDetails(agreementNo, outletId, chunkId);
      }
    } else {
      this.messageService.add({
        severity: 'info',
        summary: 'Info Message',
        detail: 'Select Outlet and Agreement Number.',
      });
    }
  }

  getEPCEstimationDetails(contractorId, outletId, agreementNo, chunkId) {
    this.loader.start();
    this.vendorService
      .getContractorEstimation(contractorId, outletId, agreementNo, chunkId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.hideGetDataButton = false;
          this.loader.close();
          let resp: any = data;
          if (resp.length > 0) {
            this.loadedEstimateDatafromServer = resp;
            let respArr = resp.map((val) => this.estimationTableData.push({
              programmeId: val?.ProgramID,
              programmeName: val?.Program_Name,
              CatID: val?.catId,
              CatName: val?.category,
              ComponentID: val?.ComponentID,
              ComponentName: val?.Component,
              // SizeID: estimationVal?.sizePrice?.sizeId,
              // SizePriceName: estimationVal?.sizePrice?.sizeAndPrice,
              Size: val?.Size,
              SizeID: val?.SizeId,
              Quantity: val?.Quantity,
              PerUnitCost: val?.PerUnitCost,
              ConPrice: val?.TotalAmount
              // CoveredArea: val?.CoveredArea
            }))
            // this.estimationTableData.concat(respArr);
          } else {
            this.loadedEstimateDatafromServer = [];
            this.estimationTableData = [];
            if (this.chunkIdToGetData) {
              this.messageService.add({
                severity: 'info',
                summary: 'Info Message',
                detail: 'Data Not Found',
              });
            }
          }
        },
        error: (err) => {
          // this.hideGetDataButton = false;
          this.loadedEstimateDatafromServer = [];
          this.estimationTableData = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  getEPCFarmerDetails(agreementNo, outletId, chunkId) {
    this.loader.start();
    this.vendorService
      .getEPCDetails(agreementNo, outletId, chunkId, this.userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          let resp: any = data;
          if (resp?.otherDetails['$values'].length > 0) {
            this.hideGetDataButton = true;
            this.calValidationForEstimation(resp?.otherDetails['$values']);
            // this.addedFarmerData = data;
            this.addedFarmerData = resp?.otherDetails['$values'];
            // this.epcDataForAppLandDetails = resp?.landDetails['$values'];
          } else {
            this.hideGetDataButton = false;
            this.addedFarmerData = [];
            this.programWiseData = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Found',
            });
          }
        },
        error: (err) => {
          this.hideGetDataButton = false;
          this.addedFarmerData = [];
          this.programWiseData = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  calValidationForEstimation(data) {
    this.totalPortableAreaCount = 0;
    this.totalPortableCount = 0;
    this.totalMiniAreaCount = 0;
    this.totalMiniCount = 0;
    this.totalDripAreaCount = 0;
    this.totalDripCount = 0;

    data.map((val) => {
      if (val.ProposedSystem == 'Portable Sprinkler') {
        this.totalPortableAreaCount += parseFloat(val.TotalArea);
        this.totalPortableCount += 1;
      } else if (val.ProposedSystem == 'Mini Sprinkler') {
        this.totalMiniAreaCount += parseFloat(val.TotalArea);
        this.totalMiniCount += 1;
      } else if (val.ProposedSystem == 'Drip') {
        this.totalDripAreaCount += parseFloat(val.TotalArea);
        this.totalDripCount += 1;
      }
    });

    this.programWiseData = [
      {
        progName: 'Portable Sprinkler',
        totaAreaCount: this.totalPortableAreaCount,
        totalCount: this.totalPortableCount,
      },
      {
        progName: 'Mini Sprinkler',
        totaAreaCount: this.totalMiniAreaCount,
        totalCount: this.totalMiniCount,
      },
      {
        progName: 'Drip',
        totaAreaCount: this.totalDripAreaCount,
        totalCount: this.totalDripCount,
      },
    ];

    this.componentMasterListForEstimation = [
      {
        Program_Id: 1,
        Program_Name: 'Portable Sprinkler',
        Active: true,
        disabled: this.totalPortableAreaCount == 0
      },
      {
        Program_Id: 2,
        Program_Name: 'Mini Sprinkler',
        Active: true,
        disabled: this.totalMiniAreaCount == 0
      },
      {
        Program_Id: 3,
        Program_Name: 'Drip',
        Active: true,
        disabled: this.totalDripAreaCount == 0
      },
    ]
  }

  onSubmitForm() {

    if (this.addedFarmerData < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Please add farmer details.',
      });
      return;
    } else if (this.addedFarmerData > 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Only one farmer estimation allowed at a time.',
      });
      return;
    }

    if(this.consentCheckBox.length == 0){
      this.messageService.add({
        severity: 'info',
        summary: 'Info Message',
        detail: 'Please click on concent check box.',
      });
      return;
    }

    
    let sumOfComponentAmount = Math.round(this.estimationTableData.reduce((sum, item) => sum + parseFloat(item['ConPrice']), 0))
    if(this.selectedFarmerForEstimation[0]?.OutletAmount != sumOfComponentAmount){
      this.messageService.add({
        severity: 'info',
        summary: 'Info Message',
        detail: `As per entered area and pre defined rates total Outlet Amount ₹(${this.selectedFarmerForEstimation[0]?.OutletAmount}) must be equal to sum of all Component Amount ₹(${sumOfComponentAmount}). Here we are getting a difference of (${(this.selectedFarmerForEstimation[0]?.OutletAmount - sumOfComponentAmount).toFixed(2)}).`,
      });
      return;
    }


    let reqBody = {
      estData: this.estimationTableData.map((val) => ({
        progId: val?.programmeId,
        catID: parseInt(val?.CatID),
        componentID: parseInt(val?.ComponentID),
        sizeID: parseInt(val?.SizeID),
        quantity: val?.Quantity,
        autoIdPriceTable: parseInt(val?.SizeID),
        perUnitCost: val?.PerUnitCost,
        totalAmount: parseInt(val?.ConPrice),
      })),
      farmerData: this.selectedFarmerForEstimation.map((val) => ({
        appId: val?.APP_ID,
        farmerId: val?.Farmer_ID
      })),
      contractorId: parseInt(this.contractorId),
      outletId: this.selectedOutletToGetData?.OutletId,
      agreementNo: this.agreementNoToGetData?.AgreementNo,
      network_ID: this.ipAddress,
      terminal_ID: this.ipAddress,
    };

    this.postEPCFarmerDetails([reqBody]);
  }

  postEPCFarmerDetails(reqBody) {
    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }
    this.loader.start();
    this.vendorService
      .insertContractorEstimation(reqBodyFinal)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data == 'Success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });

            this.hideGetDataButton = false;
            this.addedFarmerData = [];
            this.programWiseData = [];
            this.estimationTableData = [];
            this.selectedFarmerForEstimation = [];

            this.clearGetData();
          } else if(data.startsWith('Violation of PRIMARY KEY')){
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'You have added the same component multiple times. Please remove the duplicate one.',
            });
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }

          this.activityRecordService.activityRecord(this.userId, 'EPC Work Estimation Submit', `${reqBody[0]?.outletId}_${reqBody[0]?.agreementNo}`, new Date(), `${data}`, JSON.stringify(reqBody[0]));

        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(this.userId, 'EPC Work Estimation Submit Error', `${reqBody[0]?.outletId}_${reqBody[0]?.agreementNo}`, new Date(), `${err}`, JSON.stringify(reqBody[0]));
        },
      });
  }

  // onSelectProgramme(){
  //   this.estimationDetailsForm.controls['vendor'].reset();
  //   this.miVendorList = [];
  //   this.estimationDetailsForm.controls['category'].reset();
  //   this.category = [];
  //   this.estimationDetailsForm.controls['component'].reset();
  //   this.component = [];
  //   this.estimationDetailsForm.controls['sizePrice'].reset();
  //   this.sizePrice = [];
  //   this.estimationDetailsForm.controls['enteredQuantity'].reset();
  //   this.estimationDetailsForm.controls['coveredArea'].reset();

  //   let estimationDetails = this.estimationDetailsForm.controls['programmeName'].value;
  //   this.getVendorList(estimationDetails?.Program_Id);
  // }

  getVendorList(programId) {
    this.loader.start();
    this.fApplicationService
      .getAllMIvenders(programId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.miVendorList = res;
        },
        error: (err) => {
          this.loader.close();
          this.miVendorList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  filterMIVendor(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.miVendorList.length; i++) {
      const vendor = this.miVendorList[i];
      if (vendor.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(vendor);
      }
    }
    this.filteredmiVendorList = filtered;
  }

  // onVendorSelect(val){
  onSelectProgramme() {
    this.estimationDetailsForm.controls['category'].reset();
    this.category = [];
    this.estimationDetailsForm.controls['component'].reset();
    this.component = [];
    this.estimationDetailsForm.controls['sizePrice'].reset();
    this.sizePrice = [];
    this.estimationDetailsForm.controls['enteredQuantity'].reset();
    this.estimationDetailsForm.controls['coveredArea'].reset();

    this.showErrMsgOfInvArea = false;
    this.invAreaMsg = null;

    // let vendor = this.estimationDetailsForm.controls['vendor'].value;
    let vendor = 0;
    let programme = this.estimationDetailsForm.controls['programmeName'].value;
    this.getCategoryDropdown(vendor, programme?.Program_Id);

    let program = this.estimationDetailsForm.controls['programmeName'].value;
    if (program.Program_Id == 1) {
      this.estimationDetailsForm.patchValue({ coveredArea: this.totalPortableAreaCount });
    } else if (program.Program_Id == 2) {
      this.estimationDetailsForm.patchValue({ coveredArea: this.totalMiniAreaCount });
    } else if (program.Program_Id == 3) {
      this.estimationDetailsForm.patchValue({ coveredArea: this.totalDripAreaCount });
    }
  }

  getCategoryDropdown(vendorId, programId) {
    const reqBody = {
      VendorRegId: vendorId,
      ProgramId: programId,
    };
    this.loader.start();
    this.vendorService
      .getCategory(reqBody)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.category = res.$values;
          this.loader.close();
        },
        error: (err) => {
          this.loader.close();
          this.category = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectCategory() {
    this.estimationDetailsForm.controls['component'].reset();
    this.component = [];
    this.estimationDetailsForm.controls['sizePrice'].reset();
    this.sizePrice = [];
    this.estimationDetailsForm.controls['enteredQuantity'].reset();
    // this.estimationDetailsForm.controls['coveredArea'].reset();

    let programme = this.estimationDetailsForm.controls['programmeName'].value;
    let category = this.estimationDetailsForm.controls['category'].value;
    // let vendor = this.estimationDetailsForm.controls['vendor'].value;
    let vendor = 0;
    this.getComponentDropdown(
      vendor,
      programme?.Program_Id,
      category?.categoryId
    );
  }

  getComponentDropdown(vendorId, programId, categoryId) {
    const reqBody = {
      VendorRegId: vendorId,
      ProgramId: programId,
      CategoryId: categoryId,
    };

    this.loader.start();
    this.vendorService
      .getComponent(reqBody)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.component = res.$values;
        },
        error: (err) => {
          this.loader.close();
          this.component = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectComponent() {
    this.estimationDetailsForm.controls['sizePrice'].reset();
    this.sizePrice = [];
    this.estimationDetailsForm.controls['enteredQuantity'].reset();
    // this.estimationDetailsForm.controls['coveredArea'].reset();

    let programme = this.estimationDetailsForm.controls['programmeName'].value;
    let category = this.estimationDetailsForm.controls['category'].value;
    // let vendor = this.estimationDetailsForm.controls['vendor'].value;
    let vendor = 0;
    let component = this.estimationDetailsForm.controls['component'].value;
    this.getSizeAndPriceDropdown(
      vendor,
      programme?.Program_Id,
      category?.categoryId,
      component?.componentId
    );
  }

  getSizeAndPriceDropdown(vendorRegId, programId, categoryId, componentId) {
    const reqBody = {
      VendorRegId: vendorRegId,
      ProgramId: programId,
      CategoryId: categoryId,
      ComponentId: componentId,
    };

    this.loader.start();
    this.vendorService
      .getSizeAndPrice(reqBody)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.sizePrice = res.$values.map((val) => ({
            ...val,
            sizeOnly: val?.sizeAndPrice.split('and')[0],
          }));
          this.loader.close();
        },
        error: (err) => {
          this.loader.close();
          this.sizePrice = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectSizePrice() {
    this.estimationDetailsForm.controls['enteredQuantity'].reset();
    // this.estimationDetailsForm.controls['coveredArea'].reset();

    let sizePrice = this.estimationDetailsForm.controls['sizePrice'].value;
  }

  addEstimateData() {
    if (this.estimationDetailsForm.valid) {
      let estimationVal = this.estimationDetailsForm.value;

      this.showErrMsgOfInvArea = false;
      this.invAreaMsg = null;

      if (estimationVal?.programmeName?.Program_Name == 'Portable Sprinkler') {
        if (estimationVal?.coveredArea > this.totalPortableAreaCount) {
          this.showErrMsgOfInvArea = true;
          this.invAreaMsg = `Covered area (i.e. ${estimationVal?.coveredArea} acres) for ${estimationVal?.programmeName?.Program_Name} can not be greater than total benefited area (i.e. ${this.totalPortableAreaCount} acres).`;
          return;
        }
      } else if (
        estimationVal?.programmeName?.Program_Name == 'Mini Sprinkler'
      ) {
        if (estimationVal?.coveredArea > this.totalMiniAreaCount) {
          this.showErrMsgOfInvArea = true;
          this.invAreaMsg = `Covered area (${estimationVal?.coveredArea}) for ${estimationVal?.programmeName?.Program_Name} can not be greater than total benefited area (${this.totalMiniAreaCount}).`;
          return;
        }
      } else if (estimationVal?.programmeName?.Program_Name == 'Drip') {
        if (estimationVal?.coveredArea > this.totalDripAreaCount) {
          this.showErrMsgOfInvArea = true;
          this.invAreaMsg = `Covered area (${estimationVal?.coveredArea}) for ${estimationVal?.programmeName?.Program_Name} can not be greater than total benefited area (${this.totalDripAreaCount}).`;
          return;
        }
      }

      // let totalPortableArea = 0;
      // let totalMiniArea = 0;
      // let totalDripArea = 0;

      // if(this.estimationTableData.length > 0){
      //   this.estimationTableData.map(val => {
      //     if(val.programmeName == "Portable Sprinkler"){
      //       totalPortableArea += parseInt(val.coveredArea);
      //     }else if(val.programmeName == "Mini Sprinkler"){
      //       totalMiniArea += parseInt(val.coveredArea);
      //     }else if(val.programmeName == "Drip"){
      //       totalDripArea += parseInt(val.coveredArea);
      //     }
      //   })
      // }


      // if(estimationVal?.programmeName?.Program_Name == "Portable Sprinkler"){
      //   totalPortableArea += parseInt(estimationVal.coveredArea);
      // }else if(estimationVal?.programmeName?.Program_Name == "Mini Sprinkler"){
      //   totalMiniArea += parseInt(estimationVal.coveredArea);
      // }else if(estimationVal?.programmeName?.Program_Name == "Drip"){
      //   totalDripArea += parseInt(estimationVal.coveredArea);
      // }


      // if(totalPortableArea > this.totalPortableAreaCount){
      //   this.messageService.add({
      //     severity: 'info',
      //     summary: 'Info Message',
      //     detail: `You have entered large area ${estimationVal?.programmeName?.Program_Name}`,
      //   });
      //   return;
      // }else if(totalMiniArea > this.totalMiniAreaCount){
      //   this.messageService.add({
      //     severity: 'info',
      //     summary: 'Info Message',
      //     detail: `You have entered large area ${estimationVal?.programmeName?.Program_Name}`,
      //   });
      //   return;
      // }else if(totalDripArea > this.totalDripAreaCount){
      //   this.messageService.add({
      //     severity: 'info',
      //     summary: 'Info Message',
      //     detail: `You have entered large area ${estimationVal?.programmeName?.Program_Name}`,
      //   });
      //   return;
      // }

      this.estimationTableData.push({
        programmeId: estimationVal?.programmeName?.Program_Id,
        programmeName: estimationVal?.programmeName?.Program_Name,
        // vendorId: estimationVal?.vendor?.Vendor_Code,
        // vendorName: estimationVal?.vendor?.Name,
        CatID: estimationVal?.category?.categoryId,
        CatName: estimationVal?.category?.categoryName,
        ComponentID: estimationVal?.component?.componentId,
        ComponentName: estimationVal?.component?.componentName,
        SizeID: estimationVal?.sizePrice?.sizeId,
        // SizePriceName: estimationVal?.sizePrice?.sizeAndPrice,
        Size: estimationVal?.sizePrice?.sizeAndPrice.split('and')[0],
        // Price: estimationVal?.sizePrice?.sizeAndPrice
        //   .split('and')[1]
        //   .split(' ')[2],
        Quantity: estimationVal?.enteredQuantity,
        PerUnitCost: estimationVal?.perUnitCost,
        ConPrice: Number(Number(estimationVal?.perUnitCost) * Number(estimationVal?.enteredQuantity)).toFixed(2)
        // CoveredArea: estimationVal?.coveredArea,
        // Amount:
        //   parseFloat(
        //     estimationVal?.sizePrice?.sizeAndPrice.split('and')[1].split(' ')[2]
        //   ) * estimationVal?.enteredQuantity,
      });

      // this.grandTotalCost = Number(this.estimationTableData.reduce((sum, d) => sum + (d['ConPrice'] || 0), 0))
      this.calculateGrandTotal();
      // setTimeout(()=> {
      //   this.calculateGrandTotal();
      // }, 200)

      this.estimationDetailsForm.reset();
      this.category = [];
      this.component = [];
      this.sizePrice = [];
    } else {
      this.estimationDetailsForm.markAllAsTouched();
      // this.messageService.add({
      //   severity: 'info',
      //   summary: 'Info Message',
      //   detail: 'Fill Estimation Details Properly.',
      // });
    }
  }

  calculateGrandTotal(){
    this.grandTotalCost = 0;

    this.grandTotalCost = Number(this.estimationTableData.reduce((sum, d) => sum + Number(d.ConPrice), 0));
    this.grandTotalQuantity = this.estimationTableData.reduce((sum, d) => sum + (d['Quantity'] || 0), 0)
  }

  onDeleteEstimationRow(val, index) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      // message: `Do you want to remove Estimation of Vendor: ${val?.vendorName} and Amount ${val?.Amount}?`,
      message: `Do you want to remove estimation?`,
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: 'p-button-danger p-button-text',
      rejectButtonStyleClass: 'p-button-text p-button-text',
      acceptIcon: 'none',
      rejectIcon: 'none',

      accept: () => {
        this.estimationTableData.splice(index, 1);
      },
      reject: () => {
        // this.messageService.add({ severity: 'info', summary: 'Rejected', detail: 'You have rejected' });
      },
    });
  }

  toggleRow(rowData: any) {
    if (this.expandedRows[rowData.landDetails]) {
      delete this.expandedRows[rowData.landDetails];
    } else {
      this.expandedRows[rowData.landDetails] = true;
    }
  }

  onRowSelect(val) {
    let farmerDataArr = val.data
    this.selectedFarmerForEstimation = [farmerDataArr];


    if(farmerDataArr?.OutletAmount == null || val?.OutletAmount == 0){
      this.messageService.add({
        severity: 'info',
        summary: 'Info Message',
        detail: 'Contact with the department.',
      });
      return;
    }

    this.calValidationForEstimation(this.selectedFarmerForEstimation);
    if(!this.chunkIdToGetData){
      this.estimationTableData = [];
    }

  }

  onRowUnselect(val) {
    this.selectedFarmerForEstimation = [];
    this.calValidationForEstimation(this.selectedFarmerForEstimation);
    this.estimationTableData = [];
  }

  clearGetData() {
    this.hideGetDataButton = false;
    this.addedFarmerData = [];
    this.programWiseData = [];
    this.estimationDetailsForm.reset();
    this.category = [];
    this.component = [];
    this.sizePrice = [];

    this.selectedOutletToGetData = null;
    this.selectedBenefitedAreaToGetData = null;
    this.agreementNoList = [];
    this.agreementNoToGetData = null;
    this.chunkList = [];
    this.chunkIdToGetData = null;

    this.estimationTableData = [];

    this.selectedFarmerForEstimation = [];
  }

  editPersonalDetails(val) {
    this.showUpdatePersonalDialog = true;
    this.selectedApplicationNo = val.APP_ID;
    this.selectedFarmerId = val.Farmer_ID;


    this.updatePersonalDetailsForm.patchValue({ name: val.Name });
    this.updatePersonalDetailsForm.patchValue({ fatherName: val.Father_name });
    this.updatePersonalDetailsForm.patchValue({ mobileNo: val.Mobile });

    this.updatePersonalDetailsForm.patchValue({ mfmbNo: val.MFMBNo });
    this.updatePersonalDetailsForm.patchValue({ pppId: val.PPP_ID });
    this.updatePersonalDetailsForm.patchValue({ casteCode: val.Caste_Code });

    // let village = this.villageList?.filter(val => val?.Code === val?.Village_Code)[0];
    let village = this.villageList?.find(({ val }) => val?.Code === val?.Village_Code);
    // this.updatePersonalDetailsForm.villageCode.setValue(village?.Name);
    // this.selectedVillage = village;

    this.updatePersonalDetailsForm.patchValue({ villageCode: village });
    this.updatePersonalDetailsForm.patchValue({ componentMaster: val.ProposedSystemId });
    this.updatePersonalDetailsForm.patchValue({ farmerCategory: val.FarmerCategory });

    this.updatePersonalDetailsForm.patchValue({ aadharNo: val.Aadhar_No });
    this.updatePersonalDetailsForm.patchValue({ aadharPhotoPath: val.Aadhaar_Copy_Upload });
    this.updatePersonalDetailsForm.patchValue({ isSubsidyAvailabe: val.IsSubsidyAvailabe });

    this.onSelectSubsidyAvailUpdate(val.IsSubsidyAvailabe);

    this.updatePersonalDetailsForm.patchValue({ installedSystem: val.InstalledSystem1 });
    this.updatePersonalDetailsForm.patchValue({ yearSubsudy: val.YearSubsudy });
    this.updatePersonalDetailsForm.patchValue({ onCostSubsidyBased: val.OnCostSubsidyBased });
    this.updatePersonalDetailsForm.patchValue({ departmentSubsidy: val.DepartmentSubsidy });
  }

  deletePersonalDetails(val) {
    let reqBody = {
      appId: val?.APP_ID,
      contractorId: this.contractorId,
      agreementNo: this.agreementNoToGetData?.AgreementNo,
      outletId: this.selectedOutletToGetData?.OutletId,
      ChunkId: this.chunkIdToGetData?.ChunkId ? this.chunkIdToGetData?.ChunkId : 0,
      network_Id: this.ipAddress,
      terminal_Id: this.ipAddress
    }

    this.delConfirmatioMsg(reqBody);
  }

  delConfirmatioMsg(reqBody) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Do you want to delete ${reqBody?.appId} record? Once you delete this farmer data, estimation should also be deleted.`,
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: "p-button-danger p-button-text",
      rejectButtonStyleClass: "p-button-text p-button-text",
      acceptIcon: "none",
      rejectIcon: "none",

      accept: () => {
        this.deleteFarmerPersonalData(reqBody);
      },
      reject: () => {
        // this.messageService.add({ severity: 'info', summary: 'Rejected', detail: 'You have rejected' });
      }
    });
  }

  deleteFarmerPersonalData(reqBody) {
    this.loader.start();
    this.vendorService
      .deleteFarmerPersonalDetails(reqBody)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          let resp: any = res;
          if (resp == 'Success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: resp,
            });

            this.hideGetDataButton = false;
            this.addedFarmerData = [];
            this.programWiseData = [];
            this.estimationTableData = [];

            this.clearGetData();

          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Error Message',
              detail: resp,
            });
          }

          this.activityRecordService.activityRecord(this.userId, 'EPC Work Delete(Farmer Data)', `${reqBody?.outletId}_${reqBody?.agreementNo}`, new Date(), `${resp}`, JSON.stringify(reqBody));
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(this.userId, 'EPC Work Delete Error(Farmer Data)', `${reqBody?.outletId}_${reqBody?.agreementNo}`, new Date(), `${err}`, JSON.stringify(reqBody));
        },
      });
  }

  onCloseUpdatePerDialog() {
    this.showUpdatePersonalDialog = false;
  }

  onClickAgreementNo() {
    let outletId = this.selectedOutletToGetData?.OutletId;
    let contractorId = this.selectedOutletToGetData?.ContractorCode;
    let agreementNo = this.agreementNoToGetData?.AgreementNo;

    this.getChunkIdsList(contractorId, agreementNo, outletId, this.userId, '');
  }

  getChunkIdsList(contractorId, agreementNo, outletId, userId, status) {
    this.loader.start();
    this.fApplicationService
      .getChunkIds(contractorId, agreementNo, outletId, userId, status)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.chunkList = res.map(val => ({
            ...val,
            combineData: `${val?.ChunkId}. ${val?.FarmerName} (${val?.AppId})`
          }));
        },
        error: (err) => {
          this.loader.close();
          this.chunkList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }
}
